export const removeProperty: any = (propKey: string, { [propKey]: propValue, ...rest }: any) => rest;

export const removeProperties: any = (object: any, ...keys: any[]) =>
  keys.length ? removeProperties(removeProperty(keys.pop(), object), ...keys) : object;

export const precisionRound: any = (num: number, fractionDigits: number = 2) => {
  return parseFloat(Number(num).toFixed(fractionDigits));
};

export const toFixedNumber: any = (num: number, fractionDigits: number = 2) => {
  return num?.toFixed(fractionDigits) as unknown as number;
};
